import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Menu, X } from "lucide-react";
import { useState } from "react";

export const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  const linkClass = (path) =>
    `text-sm font-semibold transition-colors ${
      isActive(path) ? "text-primary" : "text-foreground/80 hover:text-primary"
    }`;

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-border/40" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 text-primary" data-testid="nav-logo">
          <Home className="w-6 h-6" />
          <span className="font-bold text-xl">Kokan Homestays</span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          <Link to="/listings" className={linkClass("/listings")} data-testid="nav-listings">Homestays</Link>
          <Link to="/locations" className={linkClass("/locations")} data-testid="nav-locations">Locations</Link>
          <Link to="/places" className={linkClass("/places")} data-testid="nav-places">Places</Link>
          <Link to="/blog" className={linkClass("/blog")} data-testid="nav-blog">Blog</Link>
        </div>

        <div className="hidden md:block">
          <Link to="/list-your-homestay" data-testid="nav-list-homestay">
            <Button className="bg-primary text-white hover:bg-primary/90 rounded-full px-6 text-sm font-medium">
              List Your Homestay
            </Button>
          </Link>
        </div>

        {/* Mobile */}
        <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-testid="nav-mobile-toggle">
          {isMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-border/40 px-4 py-4 space-y-1 animate-fade-in">
          {[
            { to: "/listings", label: "Homestays", testId: "nav-mobile-listings" },
            { to: "/locations", label: "Locations", testId: "nav-mobile-locations" },
            { to: "/places", label: "Places", testId: "nav-mobile-places" },
            { to: "/blog", label: "Blog", testId: "nav-mobile-blog" },
          ].map(({ to, label, testId }) => (
            <Link
              key={to}
              to={to}
              className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive(to) ? "bg-primary text-white" : "text-foreground hover:bg-muted"
              }`}
              onClick={() => setIsMenuOpen(false)}
              data-testid={testId}
            >{label}</Link>
          ))}
          <Link to="/list-your-homestay" className="block px-4 py-2.5 rounded-lg text-sm font-medium bg-primary/10 text-primary" onClick={() => setIsMenuOpen(false)} data-testid="nav-mobile-list-homestay">
            List Your Homestay
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
